<div class="available">
  <h3>Available</h3>
  <data-table (detail)="assignItem($event)" *ngIf="availableItemsProvider" [columns]="columns" [dataProviderParams]="{}"
                  [dataProvider]="availableItemsProvider" [table_id]="appTranslation.translation.language + '-available'"></data-table>
</div>

<div class="assigned">
  <h3>Assigned
    <button (click)="addSubmenuItem()" class="fab-button add-button" color="primary" mat-fab><mat-icon>add</mat-icon></button>
  </h3>
  <data-table #assignedItemsTable (edit)="editItem($event)" (remove)="removeAssignedItem($event)" *ngIf="!!assignedItems?.length"
                  [columns]="assignedColumns" [identifier]="appTranslation.translation.language" [plainData]="assignedItems"
                  [table_id]="appTranslation.translation.language + '-assigned'"></data-table>
</div>
